module.exports = __webpack_public_path__ + "img/strength-reliable.2d61078f.png";